import React,{useEffect, useState,useRef} from "react";
import { useSelector,useDispatch } from 'react-redux'
import Layout from "../components/Layout";
import CompetencyForm from './forms/competencyForm';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column'
import { Button } from 'primereact/button';
import {fetchCompetency} from '../redux/features/competency.feature'
import { Toast } from 'primereact/toast';
import { BASE_URL } from '../utils/commonUrl';
import axios from 'axios';

const Competency = () => {
    const dispatch = useDispatch();
    const primeToast = useRef(null)
    const state = useSelector((state) => { return state["competency"] })
    const [start] = useState(0);
    const [modal, setModal] = useState(false)
    const [competencyItem, setCompetencyItem] = useState({ competencyName: '',competencyDefination:'',weight:0, active: true, competencyID: 0 })

    useEffect(() => {
        dispatch(fetchCompetency())

    }, [])
    const onSubmit = async data => {
        try {
            const url = BASE_URL + "/api/competency";
            const response = await axios.post(url, data);
            if (response.status === 200) {
                primeToast.current.show({ severity: 'success', summary: 'success', detail: 'Competency Save successfully', life: 3000 });
                setCompetencyItem({ competencyName: '',competencyDefination:'',weight:0, active: true, competencyID: 0 });
                setModal(!modal)
                dispatch(fetchCompetency())
            }
        } catch (e) {
            console.log(e)
            primeToast.current.show({ severity: 'error', summary: 'error', detail: 'An Error ', life: 3000 });
        }

    }

    const onFormHide = () => {
        setCompetencyItem({ competencyName: '',competencyDefination:'',weight:0, active: true, competencyID: 0 });
        setModal(!modal)
    }

    const editGridData = data => {
        setCompetencyItem({ competencyName: data.competencyName,competencyDefination:data.competencyDefination,weight:data.weight, active: data.active, competencyID: data.competencyID });      
        setModal(!modal);
    }

    const deleteGridData = data => {
        //setDeleteQuarterItem({quarterName:data.quarterName,quarterId:data.quarterID})
        //setDeleteProductDialog(true)
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => editGridData(rowData)} />
             &nbsp;   <Button icon="pi pi-trash" className="p-button-rounded p-button-warning" onClick={() => deleteGridData(rowData)} />
            </React.Fragment>
        );
    }

    const header = (
        <div className="table-header">
            <div className='d-flex justify-content-end'>
                <button type='button' onClick={() => setModal(!modal)} className='btn btn-primary'>Add Competency</button>
            </div>
        </div>
    );
    const footer = `In total there are ${state.competency ? state.competency.length : 0} competency.`;
    const _isActiveColumn = (rowData) =>{
        return <div>{rowData.active ? <>Active</>:<>Inactive</>}</div>
    }

    const Table = (
        <DataTable value={state.competency} header={header} footer={footer} paginator rows={7} first={start}
            paginatorTemplate="RowsPerPageDropdown PageLinks FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink">
            <Column field="competencyID" header="Competency ID" hidden={true}/>
            <Column field='competencyName' header="Competency Name" />            
            <Column field='competencyDefination' header="Competency Definition" />
            <Column field='weight' header="RCL" />
            <Column field='active' header="Active" body={_isActiveColumn} />
            <Column body={actionBodyTemplate} header="Action" exportable={false} style={{minWidth: '4rem'}}/>
        </DataTable>
    )

    return (
        <Layout>
            <Toast ref={primeToast}/>
            <CompetencyForm
                modal={modal}
                active={true}
                competencyID={competencyItem.competencyID}
                competencyName={competencyItem.competencyName}                
                competencyDefination={competencyItem.competencyDefination}
                weight={competencyItem.weight}
                onSubmit={onSubmit}
                onHide={onFormHide} />
                {Table}
        </Layout>
    );
};

export default Competency;
